#import "../../../../core/email-marketing/graphql/fragments/em-from-address-fragment.graphql"
#import "./edition-stub-fragment.graphql"
#import "./audience-fragment.graphql"

fragment EditionFragment on Edition {
    ...EditionStubFragment
    numSentEmails
    from {
        ...FromAddress
    }
    customClickDomain {
        isVerified
    }
    utmParameters {
        source
        medium
        campaign
    }
    defaultUtmParameters {
        source
        medium
        campaign
    }
    hasStreetAddress
    hasUnsubscribeLink
    useUtmParameters
    engagementStats {
        totalSentCount
    }
    gateError {
        reason
        message
    }
    hasWebFonts
    audience {
        ...AudienceFragment
    }
    lastSentTime
    isFirstEdition
    emailTemplate {
        id
        name
        subject
        previewText
        links {
            link
            url {
                id
                fullyQualifiedUrl
            }
            numTimesSent
            numTotalClicks
            numUniqueClicks
        }
        bodyForWeb
    }
    queuedDripProgressions {
        totalCount
        pageInfo {
            startCursor
            endCursor
            hasNextPage
            hasPreviousPage
        }
        edges {
            node {
                id
                audienceMember {
                    id
                    audience {
                        id
                    }
                    entity {
                        id
                        name
                        avatarUrl
                        htmlUrlPath
                        ... on Contact {
                            emailAddresses {
                                primary {
                                    value {
                                        display
                                    }
                                }
                            }
                            accounts {
                                primary {
                                    id
                                    name
                                }
                            }
                        }
                    }
                }
                nextEditionSendTime
            }
        }
    }
    engagementStats {
        unsubscribeCount
        unsubscribeRate
        permanentBounceCount
    }
    recipientLimitForDeliverability
}
